import * as requestFromServer from "./Crud";
import { apkSlice, callTypes } from "./apkSlice";
import { NotificationManager } from "react-notifications";

const { actions } = apkSlice;

export const fetchAPKScreenList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAPKScreenList(queryParams)
    .then((response) => {
      console.log("data Data ", response)
      const totalCount = response.count;
      const entities = response.list;
      dispatch(actions.screenList({ totalCount, entities }));
      return response
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      console.log("errMsg:", errMsg);
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCompanyDropdownList = (queryParams) => (dispatch) => {
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .fetchCompanyDropdownList(queryParams)
    .then((response) => {
      console.log("response::All Company List", response);
      // const { totalCount, entities } = response.data;
      const companyDropdownList = response;
      console.log("fetchCompanyDropdownList", companyDropdownList);
      dispatch(actions.CompanyDropdownList({ companyDropdownList }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchCompanyList = (queryParams) => (dispatch) => {
  // console.log("queryParams",queryParams)
  dispatch(actions.emptyList());
  dispatch(actions.startCall({ callType: callTypes.list }));
  // console.log('queryParams: ', queryParams)
  return requestFromServer
    .getCompany(queryParams)
    .then((response) => {
      // console.log("response::getGameList ", response);
      // const { totalCount, entities } = response.data;
      const totalCount = response.totalRecord;
      const entities = response.data;
      dispatch(actions.company({ totalCount, entities }));
    })
    .catch((error) => {
      const errMsg =
        error.response && error.response.data && error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message;
      NotificationManager.error(errMsg, "Error");
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const fetchList = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getList(queryParams)
    .then(response => {
      // const { totalCount, entities } = response.data;
      const totalCount = response?.count;
      const entities = response?.list;      
      dispatch(actions.listFetched({ totalCount, entities }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSingle = id => dispatch => {
  if (!id) {
    return dispatch(actions.singleItemFetched({ apkScreenForEdit: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getItemById(id)
    .then(response => {
      const item = response;
      dispatch(actions.singleItemFetched({ apkScreenForEdit: item }));
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteItem = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItem(id)
    .then(response => {
      dispatch(actions.itemDeleted({ id }));
      NotificationManager.success('success', 'Data deleted successfully!');
    })
    .catch(error => {
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  console.log('item    ::::::::     ', JSON.stringify(item));
  return requestFromServer
    .createItem(item)
    .then(response => {
      const { item } = response.item;
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemCreated({ item }));
      return true;
    })
    .catch(error => {
      const errMsg =
        error.response?.data?.errors?.[0]?.msg || error.message || 'Unknown error';
      if (errMsg === 'apkScreens.validation.name_exists') {
        NotificationManager.error('APK Screen Name already exists', 'Error');
      } else {
        NotificationManager.error(errMsg, 'Error');
      }
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};


export const updateItem = item => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItem(item)
    .then(() => {
      NotificationManager.success('success', 'Data saved successfully!');
      dispatch(actions.itemUpdated({ item }));
      return true ;
    })
    .catch(error => {
      // error.clientMessage = "Can't update item";
      const errMsg =
      error.response?.data?.errors?.[0]?.msg || error.message || 'Unknown error';
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ errMsg, callType: callTypes.action }));
      return false ;
    });
};
export const updateItemsStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateItemsStatus(ids, status)
    .then(() => {
      dispatch(actions.itemStatusUpdated({ ids, status }));
    })
    .catch(error => {
      // error.clientMessage = "Can't update items status";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteItems = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteItems(ids)
    .then(() => {
      dispatch(actions.itemsDeleted({ ids }));
      
    })
    .catch(error => {
      // error.clientMessage = "Can't delete items";
      const errMsg = error.response && error.response.data && error.response.data.errors ? error.response.data.errors[0].msg : error.message ;
        NotificationManager.error(errMsg, 'Error');
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};